import styled from 'styled-components';

const Heading = styled.div`
  padding: 1.25rem 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.light};

  @media ${props => props.theme.breakpoints.lg} {
    padding: 1.25rem 0;
  }
`;

export default Heading;
